import Navbar from "../../components/shared/Navbar";
import Footer from "../../components/shared/Footer";
import BreadCrumbDetailOffer from "../../components/detailOffer/BreadCrumbDetailOffer";
import Detail from "../../components/detailOffer/Detail";
import RightBar from "../../components/shared/RightBar";

export default function DetailOffer() {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbDetailOffer></BreadCrumbDetailOffer>
                <Detail></Detail>
            </main>
            <Footer />
        </div>
    )
}